export default "__VITE_ASSET__DjML6Xd8__"